﻿import {useContext} from "react";
import {WizardContext} from "./WizardContext";
import {WizardValues} from "./WizardValues";

export default function useWizard(): WizardValues {
	const context = useContext(WizardContext);

	if (!context) {
		throw Error("Wrap your step with `Wizard`");
	} else {
		return context as WizardValues;
	}
}
